'use client';
import { jsx } from "react/jsx-runtime";
import * as React from "react";
import { useState } from "react";
import { Icon } from "@tameeni/icons";
import { Button } from "../button/button.js";
import { Input } from "../input/input.js";
const PasswordInput = React.forwardRef(
  ({ className, ...props }, ref) => {
    const [isVisible, setIsVisible] = useState(false);
    const toggleVisibility = () => {
      setIsVisible((prevState) => !prevState);
    };
    return /* @__PURE__ */ jsx(
      Input,
      {
        ref,
        ...props,
        type: !isVisible || props.disabled ? "password" : "text",
        suffix: /* @__PURE__ */ jsx(Button, { onClick: toggleVisibility, variant: "text", size: "loose", children: /* @__PURE__ */ jsx(
          Icon,
          {
            name: isVisible ? "EyeHidden" : "Eye",
            className: "size-5 text-slate-900"
          }
        ) })
      }
    );
  }
);
PasswordInput.displayName = "PasswordInput";
export {
  PasswordInput
};
